import { render } from "./PersonSelect.vue?vue&type=template&id=0c0077ca&ts=true"
import script from "./PersonSelect.vue?vue&type=script&lang=ts"
export * from "./PersonSelect.vue?vue&type=script&lang=ts"

import "./PersonSelect.vue?vue&type=style&index=0&id=0c0077ca&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__